import React from "react";
import axiosService from "../utils/axios.service";
import { Link } from "react-router-dom";
import "../scss/dashboard.scss";
import * as convert from "./constant/Convert.helper";
import { Tooltip } from "antd";

class Dashboard extends React.Component {
  constructor() {
    super();
    this.state = {
      isLoaded: false,
      currentStore: localStorage.getItem("currentStore"),
      dataDashboard: {},
      userAdmin: JSON.parse(localStorage.getItem("user_info")),
    }
  }

  componentDidMount() {
    const storeId = Number(localStorage.getItem("currentStore")) || 3;
  
    axiosService(`api/dashboard/${storeId}`, "GET")
    .then((response) => {
      if (response?.data?.success) {
        this.setState({
          dataDashboard: response.data.data,
          isLoaded: true,
        });
      }
    });
  }

  render() {
    if (this.state.isLoaded) {
      return (
        <React.Fragment>
          <div className="admin-page dashboard">
            <div className="admin-body">
              <div className="dashboard-content">
                <div className="wrapper">
                  <div className="dashboard-main-button main-booking">
                    <Link to={{ pathname: "/booking" }}>
                      <div className="icon-bg"></div>
                      <div className="title">Lịch hẹn</div>
                      <i className="far fa-calendar-alt"></i>
                      <div className="report">
                        <div className="value">
                          <span className="count">{this.state.dataDashboard?.dataBookings?.[0] ?? 0}</span>
                          <div className="note">
                              <Tooltip title="Tổng số lượng lịch đặt tính từ ngày xem">
                                Sắp tới <i className="fas fa-info-circle"></i>
                              </Tooltip>
                            </div>
                        </div>
                        <div className="value">
                          <span className="count">{this.state.dataDashboard?.dataBookings?.[1] ?? 0}</span>
                          <div className="note">
                              <Tooltip title="Tổng số lượng lịch đặt trong tháng, bao gồm lịch hủy, không đến, đã xác nhận.">
                                Tháng này <i className="fas fa-info-circle"></i>
                              </Tooltip>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                  {this.state.userAdmin.role != 2 ?
                    <>
                      <div className="dashboard-main-button main-order">
                        <Link to={{ pathname: this.state.userAdmin.role != 4 ? "/pos" : "/dashboard" }}>
                          <div className="icon-bg"></div>
                          <div className="title">Thu ngân</div>
                          <i className="fas fa-calculator"></i>
                          <div className="report">
                            <div className="value">
                              <span className="count">{this.state.dataDashboard?.dataOrders?.[0] ?? 0}</span>
                              <div className="note">
                                <Tooltip title="Tổng số lượng hóa đơn hoàn thành ngày hôm đó (bao gồm có tiền và không có tiền, nâng cấp, nạp thẻ tiền, không bao gồm các hóa đơn hủy, upsale, chuyển đổi).">
                                Hóa đơn hôm nay <i className="fas fa-info-circle"></i>
                                </Tooltip></div>
                            </div>
                            <div className="value">
                              <span className="count">{convert.convertCurrency(this.state.dataDashboard?.dataOrders?.[1] ?? 0)}</span>
                              <div className="note">
                                  <Tooltip title="Tổng số tiền đã thu ngày hôm đó bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, không bao gồm sử dụng thẻ tiền và điểm tích lũy.">
                                    Tổng tiền đã thu <i className="fas fa-info-circle"></i>
                                  </Tooltip>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                      <div className="dashboard-main-button main-customer">
                        <Link to={{ pathname: "/customer" }}>
                          <div className="icon-bg"></div>
                          <div className="title">Khách hàng</div>
                          <i className="fas fa-female"></i>
                          <div className="report">
                            <div className="value">
                              <span className="count">{this.state.dataDashboard?.dataCustomers?.[0] ?? 0}</span>
                              <div className="note">
                                <Tooltip title="Tổng số lượng khách mới.">
                                  Khách mới hôm nay <i className="fas fa-info-circle"></i>
                                </Tooltip>
                              </div>
                            </div>
                            <div className="value">
                              <span className="count">{convert.convertCurrency(this.state.dataDashboard?.dataCustomers?.[1] ?? 0)}</span>
                              <div className="note">
                                <Tooltip title="Số tiền cần thu của các khách hàng mới sau khi đã trừ các khoản giảm trừ bao gồm: giảm giá, chiết khấu, thuế (nếu có).">
                                Doanh số thuần khách mới <i className="fas fa-info-circle"></i>
                                </Tooltip>

                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    </>
                  : null}
                </div>
                {this.state.userAdmin.role != 2 ?
                  <>
                    <div className="wrapper">
                      <div className="dashboard-report-button report-order">
                        <Link to={{ pathname: "/orders" }}>
                          <div className="icon"><i className="fas fa-file-invoice"></i></div>
                          <div className="title">
                              <Tooltip title="Tất cả hóa đơn hoàn thành, hủy, upsale.">
                                Danh sách hóa đơn <i className="fas fa-info-circle"></i>
                              </Tooltip>

                          </div>
                        </Link>
                      </div>
                      <div className="dashboard-report-button report-daily">
                        <Link to={{ pathname: "/report/daily" }}>
                          <div className="icon"><i className="fas fa-file-invoice-dollar"></i></div>
                          <div className="title">Báo cáo theo ngày</div>
                        </Link>
                      </div>
                      <div className="dashboard-report-button report-commission">
                        <Link to={{ pathname: "/dashboard" }}>
                          <div className="icon"><i className="fas fa-user-friends"></i></div>
                          <div className="title">Hoa hồng nhân viên</div>
                        </Link>
                      </div>
                    </div>
                    {[5,6].includes(Number(this.state.userAdmin.role)) ?
                      <div className="wrapper">
                        <div className="dashboard-report-button report-inventory">
                          <Link to={{ pathname: "/data/sale-online" }}>
                            <div className="icon"><i className="fas fa-hand-holding-usd"></i></div>
                            <div className="title">Data sale online</div>
                          </Link>
                        </div>
                      </div>
                    : null}
                  </>
                : null}

                {this.state.userAdmin.role == 1 ?
                  <div className="wrapper">
                    <div className="dashboard-setting-button setting-general">
                      <Link to={{ pathname: "/dashboard" }}>
                        <div className="title">Thông tin chung</div>
                        <div className="icon"><i className="fas fa-home"></i></div>
                      </Link>
                    </div>
                    <div className="dashboard-setting-button setting-location">
                      <Link to={{ pathname: "/stores" }}>
                        <div className="title">
                          <Tooltip title="Thêm, sửa, xóa thông tin (Ngân hàng, Số lượng KTV, Booking) của các chi nhánh mới/cũ.">
                          Quản lý chi nhánh <i className="fas fa-info-circle"></i>
                                </Tooltip>

                        </div>
                        <div className="icon"><i className="fas fa-map-marker-alt"></i></div>
                      </Link>
                    </div>
                    <div className="dashboard-setting-button setting-staff">
                      <Link to={{ pathname: "/operators" }}>
                        <div className="title">
                        <Tooltip title="Thêm, sửa, xóa thông tin nhân viên (Họ và tên, Nhóm nhân viên, Chi nhánh, Số điện thoại, Email, Trạng thái hoạt động).">
                          Nhân viên phục vụ <i className="fas fa-info-circle"></i>
                                </Tooltip>
                        </div>
                        <div className="icon"><i className="fas fa-users"></i></div>
                      </Link>
                    </div>
                    <div className="dashboard-setting-button setting-financial">
                      <Link to={{ pathname: "/dashboard" }}>
                        <div className="title">Sổ quỹ thu/chi</div>
                        <div className="icon"><i className="fas fa-money-bill"></i></div>
                      </Link>
                    </div>
                    <div className="dashboard-setting-button setting-voucher">
                      <Link to={{ pathname: "/vouchers" }}>
                        <div className="title">
                        <Tooltip title="Tạo các chương trình khuyến mãi cho khách hàng theo thời điểm.">
                          Voucher <i className="fas fa-info-circle"></i>
                                </Tooltip>

                        </div>
                        <div className="icon">
                        <i className="fas fa-window-maximize"></i>
                        </div>
                      </Link>
                    </div>
                    <div className="dashboard-setting-button setting-voucher">
                      <Link to={{ pathname: "/strapi" }}>
                        <div className="title">Quản lý Website</div>
                        <div className="icon">
                        <i className="fas fa-window-maximize"></i>
                        </div>
                      </Link>
                    </div>
                    <div className="dashboard-setting-button setting-service">
                      <Link to={{ pathname: "/services" }}>
                        <div className="title">
                          <Tooltip title="Tạo mới, quản lý các dịch vụ.">
                            Danh sách dịch vụ <i className="fas fa-info-circle"></i>
                          </Tooltip>
                        </div>
                        <div className="icon"><i className="fas fa-couch"></i></div>
                      </Link>
                    </div>
                    <div className="dashboard-setting-button setting-product">
                      <Link to={{ pathname: "/product" }}>
                        <div className="title">
                          <Tooltip title="Tạo mới, quản lý các sản phẩm bán.">
                          Danh sách sản phẩm <i className="fas fa-info-circle"></i>
                          </Tooltip>
                        </div>
                        <div className="icon"><i className="fas fa-tags"></i></div>
                      </Link>
                    </div>
                    <div className="dashboard-setting-button setting-inventory">
                      <Link to={{ pathname: "/emulation" }}>
                        <div className="title">
                        <Tooltip title="Chương trình thi đua cho nhân sự theo thời điểm.">
                        Chương trình thi đua <i className="fas fa-info-circle"></i>
                          </Tooltip>
                        </div>
                        <div className="icon"><i className="fas fa-boxes"></i></div>
                      </Link>
                    </div>
                    <div className="dashboard-setting-button setting-commission">
                      <Link to={{ pathname: "/data/sale-online" }}>
                        <div className="title">
                        <Tooltip title="Thông tin khách hàng tiềm năng nguồn Online.">
                          Data Sale Online <i className="fas fa-info-circle"></i>
                        </Tooltip>
                        </div>
                        <div className="icon"><i className="fas fa-hand-holding-usd"></i></div>
                      </Link>
                    </div>
                    <div className="dashboard-setting-button setting-member-cards">
                      {this.state.userAdmin.role == 1 ?
                        <Link to={{ pathname: "/membercards" }}>
                          <div className="title">
                          <Tooltip title="Tạo mới thẻ dịch vụ, quản lý danh sách thẻ khách hàng đã có.">
                            Thẻ thành viên <i className="fas fa-info-circle"></i>
                          </Tooltip>
                          </div>
                          <div className="icon"><i className="fas fa-address-card"></i></div>
                        </Link>
                      : null}
                    </div>
                    <div className="dashboard-setting-button empty">
                    </div>
                  </div>
                : null}
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    } else return <div></div>;
  }
}
export default Dashboard;
